import { WebPlugin } from '@capacitor/core';
export class NativeShareWeb extends WebPlugin {
    addListener(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _eventName, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _listenerFunc) {
        return new Promise((resolve) => {
            resolve({ remove: () => new Promise((res) => res()) });
        });
    }
    getLastSharedItems() {
        return new Promise((_resolve, reject) => {
            reject('Web not supported');
        });
    }
    clear() {
        return new Promise((resolve) => {
            resolve();
        });
    }
}
//# sourceMappingURL=web.js.map